import React, { useEffect, useState } from "react";
import BulkUploadsFilterMenu from "./BulkUploadsFilterMenu";
import { BulkUpload } from "../../../../Entities/BulkUpload";
import bulkUploadService from "../../../../Service/bulk.upload.service";
import BulkUploadCard from "./BulkUploadCard";
import {  Empty, Flex, List, Avatar, Typography, Space } from "antd";
import ActiveBulkUpload from "./ActiveBulkUpload";
import UploadModal from "./UploadModal";
import useAccess from "../../../../Hooks/useAccess";
import { textAlign } from "html2canvas/dist/types/css/property-descriptors/text-align";

interface BulkUploadsProps {
  jobPostId: string;
}

const processSteps = [
  {
    title: "Click on the Upload button to upload resumes in Bulk",
    description:
      "Admins can upload a ZIP file containing multiple resumes, and the system will extract and save details for all candidates.",
  },
  {
    title: "AI Profile Matching for All Candidates",
    description:
      "The extracted details for each candidate will be matched against job requirements using AI to determine their suitability.",
  },
  {
    title: "AI-Powered Interviews",
    description:
      "Qualified candidates will automatically receive an email invitation to participate in AI-driven interviews.",
  },
];


const BulkUploads: React.FC<BulkUploadsProps> = ({
  jobPostId,
}) => {
  const [bulkUploads, setBulkUploads] = useState<BulkUpload[]>([]);
  const [activeBulkUpload, setActiveBulkUpload] = useState<BulkUpload | null>(
    null,
  );
  const [showUploadModal, setShowUploadModal] = useState<boolean>(false);

  const { currentSubscription } = useAccess();

  const handleBulkUploadSuccess = async () => {
    const data = await bulkUploadService.getAllBulkUploadsRecords(jobPostId);
    setActiveBulkUpload(data[0]);
    setBulkUploads(data);
    setShowUploadModal(false);
  };

  const handleOpenBulkUploadModal = () => {
    if (!currentSubscription) {
      return;
    }
    setShowUploadModal(true);
  };

  useEffect(() => {
    const fetchBulkUploads = async () => {
      const data = await bulkUploadService.getAllBulkUploadsRecords(jobPostId);
      setActiveBulkUpload(data[0]);
      setBulkUploads(data);
    };
    fetchBulkUploads();
  }, [jobPostId]);

  const handleBulkUploadClick = (bulkUpload: BulkUpload) => {
    if (activeBulkUpload?._id === bulkUpload?._id) {
      return;
    }
    setActiveBulkUpload(bulkUpload);
  };

  const updateBulkUploadsCount = (
    bulkUploadId: string,
    noOfFilesCompleted: number,
    noOfFilesFailed: number,
  ) => {
    const updatedBulkUploads = bulkUploads.map((bulkUpload) => {
      if (bulkUpload._id === bulkUploadId) {
        return {
          ...bulkUpload,
          noOfFilesCompleted: noOfFilesCompleted,
          noOfFilesFailed: noOfFilesFailed,
        };
      }
      return bulkUpload;
    });
    setBulkUploads(updatedBulkUploads);
  };



  return (
    <section className="bulk-uploads-section">
      <BulkUploadsFilterMenu
        count={bulkUploads.length}
        handleOpenBulkUploadModal={handleOpenBulkUploadModal}
      />

      {bulkUploads.length > 0 ? (
        <div className="bulk-upload-listing-container">
          <div className="bulk-upload-listing">
            {bulkUploads.length > 0 ? (
              bulkUploads.map((bulkUpload, index) => (
                <BulkUploadCard
                  key={index}
                  bulkUpload={bulkUpload}
                  isActive={activeBulkUpload?._id === bulkUpload?._id}
                  onClick={() => handleBulkUploadClick(bulkUpload)}
                />
              ))
            ) : (
              <Empty
                description="No bulk uploads"
                image={Empty.PRESENTED_IMAGE_SIMPLE}
              />
            )}
          </div>
          <div className="bulk-upload-jobs-listing">
            <ActiveBulkUpload
              bulkUpload={activeBulkUpload}
              jobPostId={jobPostId}
              updateBulkUploadsCount={updateBulkUploadsCount}
            />
          </div>
        </div>
      ) : (
        <section className="bulk-upload-listing-empty">
          <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={(
              <Flex vertical align="center">
                <List
                  itemLayout="vertical"
                  style={{ width: '100%', maxWidth: '600px'}}
                  dataSource={processSteps}
                  renderItem={(item, index) => (
                    <List.Item>
                      <List.Item.Meta
                        avatar={<Avatar>{index + 1}</Avatar>}
                        title={item.title}
                        description={item.description}
                        style={{ textAlign: "left" }}
                      />
                    </List.Item>
                  )}
                />
            </Flex>
            )}
          // image={Empty.PRESENTED_IMAGE_SIMPLE}
          style={{width: '100%'}}
          />
        </section>
      )}

      <UploadModal
        jobDescriptionId={jobPostId}
        setShowUploadModal={setShowUploadModal}
        showUploadModal={showUploadModal}
        onUploadSuccess={handleBulkUploadSuccess}
      />
    </section>
  );
};

export default BulkUploads;
